import React from 'react';

import * as S from './CreditRefusalPopup.styles';
import { useCreditRefusalPopupPresenter } from './CreditRefusalPopup.presenter';

export const CreditRefusalPopup = () => {
  const presenter = useCreditRefusalPopupPresenter();

  if (!presenter.showCreditRefusalPopup) {
    return null;
  }

  return (
    <S.Container onClose={presenter.onCloseCreditRefusalPopupHandler}>
      <S.Title>Поставить отказ от кредита?</S.Title>
      <S.Text>Работа над заявкой будет остановлена, а отказ клиента отправлен в банки</S.Text>
      <S.Controls>
        <S.ButtonStyled theme={3} onClick={presenter.onCloseCreditRefusalPopupHandler}>
          Нет
        </S.ButtonStyled>
        <S.ButtonStyled onClick={presenter.requestOnCreditRefusal}>Да</S.ButtonStyled>
      </S.Controls>
    </S.Container>
  );
};
